import template from './confirmation.html';
import '../confirmation.scss';

/**
 * @ngdoc controller
 * @name OdsConfirmation
 * @description
 * This component renders the confirmation.
 */
class OdsConfirmation {
  /**
   * Initialize variables.
   */
  $onInit() {
    if (typeof this.destructive !== 'boolean') {
      this.destructive = false;
    }
  }
}

/**
 * @ngdoc component
 * @name OdsConfirmation
 * @description
 * The confirmation component.
 */
export default {
  /**
   * The controller class for the component.
   * @type {OdsConfirmation}
   */
  controller: OdsConfirmation,
  /**
   * The HTML template for the component.
   * @type {String}
   */
  template,
  /**
   * Component bindings
   * @type {Object}
   * @property {String}   body         the message to be displayed inside the modal.
   * @property {?String}  cancelCta    the cancel button text, we're not going to display
   *                                   the button if this value is `falsy`.
   * @property {?String}  confirmCta   the confirm button text, we're not going to display
   *                                   the button if this value is `falsy`.
   * @property {Boolean}  destructive  if it is a destructive confirmation.
   * @property {String}   header       the message to be displayed inside the modal's header.
   * @property {String}   type         the type of confirmation to display.
   * @property {Function} onClose      the callback when the close icon or the background is clicked.
   * @property {Function} onConfirm    the callback when the user confirms the action.
   */
  bindings: {
    body: '<',
    cancelCta: '<',
    confirmCta: '<',
    destructive: '<',
    header: '<',
    type: '<',
    onClose: '&',
    onConfirm: '&',
  },
};
